import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import FileSaver from "file-saver";

// routes
import {
  CREATE_BATCH_PUBLISH_ASSESSMENT,
  GET_BATCH_PUBLISH_ASSESSMENT,
  BATCH_PUBLISH_ASSESSMENT_BY_ACCOUNT_ID,
  CURD_PUBLISH_ASSESSMENT,
  GET_ARCHIVED_PUBLISH_ASSESSMENT,
  PREVIEW_REPORT_REMMINDER,
  PUBLISH_ASSESSMENT,
  PREVIEW_PUBLISH_REMMINDER,
  BULK_UPLOAD_CUSTOMER_USER,
  PUBLISH_ASSESSMENT_BY_ACCOUNT_ID,
  PUBLISH_ASSESSMENT_BY_CUSTOMER_ID,
  GET_BATCH_BY_TRACKING_ID,
  BATCH_PUBLISH_ASSESSMENT,
  CREATE_ASSESSMENT_TO_GROUP,
  DELETE_BATCH,
  DELETE_ASSESSMENT_BATCH,
  GET_BATCH_NON_PUBLISH_ASSESSMENT,
  UPDATE_BATCH_PUBLISH_ASSESSMENT,
   FORCE_DELETE_PUBLISH,
   BATCH_PUBLISH_ASSESSMENT_REMINDER,
   PREVIEW_PUBLISH_REMMINDER_BY_ASSESSMENT_ID_VIEW,
   SEND_REMMINDER_BY_CUSTOMER_USER_ID
} from "../../utils/routes";

// ---------------------------------------------------------------------

export const createPublishAssessment = createAsyncThunk(
  "publishAssessment/createPublishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_PUBLISH_ASSESSMENT, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const createBatchPublishAssessment = createAsyncThunk(
  "publishAssessment/createBatchPublishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CREATE_BATCH_PUBLISH_ASSESSMENT, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const sendReminderByUserId = createAsyncThunk(
  "publishAssessment/sendReminderByUserId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(SEND_REMMINDER_BY_CUSTOMER_USER_ID, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);


export const createAssessmentExistingBatch = createAsyncThunk(
  "publishAssessment/createAssessmentExistingBatch",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CREATE_ASSESSMENT_TO_GROUP, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getBatchPublishAssessmentById = createAsyncThunk(
  "publishAssessment/getBatchPublishAssessmentById",
  async (data, { rejectWithValue }) => {
   
    try {
      const params = new URLSearchParams();

      if (data?.customerId && !data?.accountId) {
        params.append("assessmentCustomerId", data?.customerId);
      }
       if (data?.accountId) {
          params.append("assessmentCustomerId", data?.customerId);
          params.append("assessmentCustomerAccountId", data?.accountId);
      }


      const url = params.toString()
        ? `${BATCH_PUBLISH_ASSESSMENT_BY_ACCOUNT_ID}?${params.toString()}`
        : BATCH_PUBLISH_ASSESSMENT_BY_ACCOUNT_ID;

      const response = await axios.get(url, {
        withCredentials: true,
      });

      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getBatchByTrackingId = createAsyncThunk(
  "publishAssessment/getBatchByTrackingId",
  async (data, { rejectWithValue }) => {
   
    try {
      const params = new URLSearchParams()
      params.append("assessmentTrackingId",data)

     const url = `${GET_BATCH_BY_TRACKING_ID}?${params.toString()}`
      const response = await axios.get(url, {
        withCredentials: true,
      });

      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);


export const getBatchPublishAssessment = createAsyncThunk(
  "publishAssessment/getBatchPublishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(GET_BATCH_PUBLISH_ASSESSMENT, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getBatchPreviewByAssessmentIds = createAsyncThunk(
  "publishAssessment/getBatchPreviewByAssessmentIds",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(PREVIEW_PUBLISH_REMMINDER_BY_ASSESSMENT_ID_VIEW, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getBatchNonPublishAssessment = createAsyncThunk(
  "publishAssessment/getBatchNonPublishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      if (data) {
        params.append("assessmentCustomerAccountId", data);
      }

        const url = params.toString()
        ? `${GET_BATCH_NON_PUBLISH_ASSESSMENT}?${params.toString()}`
        : GET_BATCH_NON_PUBLISH_ASSESSMENT;


      const response = await axios.get(url, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const publishAssessment = createAsyncThunk(
  "publishAssessment/publishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(PUBLISH_ASSESSMENT, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const publishBatchAssessment = createAsyncThunk(
  "publishAssessment/publishBatchAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(BATCH_PUBLISH_ASSESSMENT, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const publishBatchAssessmentReminder = createAsyncThunk(
  "publishAssessment/publishBatchAssessmentReminder",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(BATCH_PUBLISH_ASSESSMENT_REMINDER, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getPublishAssessmentById = createAsyncThunk(
  "publishAssessment/publishAssessmentById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        PUBLISH_ASSESSMENT_BY_ACCOUNT_ID,
        data,
        {
          withCredentials: true,
        },
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getArchivedPublishAssessment = createAsyncThunk(
  "publishAssessment/archivedPublishAssessmentById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(GET_ARCHIVED_PUBLISH_ASSESSMENT, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const updateArchivedPublishAssessment = createAsyncThunk(
  "publishAssessment/updateArchivedPublishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(GET_ARCHIVED_PUBLISH_ASSESSMENT, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getPreviewReminderById = createAsyncThunk(
  "publishAssessment/getPreviewReminderById ",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(PREVIEW_REPORT_REMMINDER, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getPublishPreviewReminderById = createAsyncThunk(
  "publishAssessment/getPublishPreviewReminderById ",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(PREVIEW_PUBLISH_REMMINDER, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getPublishPreviewReminderByAssessmentId = createAsyncThunk(
  "publishAssessment/getPublishPreviewReminderByAssessmentId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(PREVIEW_PUBLISH_REMMINDER_BY_ASSESSMENT_ID_VIEW, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getPublishAssessmentByCustomerId = createAsyncThunk(
  "publishAssessment/publishAssessmentByCustomerId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        PUBLISH_ASSESSMENT_BY_CUSTOMER_ID,
        data,
        {
          withCredentials: true,
        },
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getPublishAssessment = createAsyncThunk(
  "publishAssessment/getPublishAssessment",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await axios.get(CURD_PUBLISH_ASSESSMENT, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response);
    }
  },
);

export const updatePublishAssessment = createAsyncThunk(
  "publishAssessment/updatePublishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_PUBLISH_ASSESSMENT, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const updateBatchPublishAssessment = createAsyncThunk(
  "publishAssessment/updateBatchPublishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(UPDATE_BATCH_PUBLISH_ASSESSMENT, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const batchUploadCustomerUser = createAsyncThunk(
  "Assessment/bulkUploadCustomerUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(BULK_UPLOAD_CUSTOMER_USER, data, {
        withCredentials: true,
        responseType: "blob",
      });
      FileSaver.saveAs(new Blob([response.data]), "data.xlsx");
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const deletePublishAssessmentFromGroup = createAsyncThunk(
  "publishAssessment/deletePublishAssessmentFromGroup",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(DELETE_ASSESSMENT_BATCH, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const deletePublishAssessment = createAsyncThunk(
  "publishAssessment/deletePublishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_PUBLISH_ASSESSMENT, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

// export const deletePublishAssessmentFromGroup = createAsyncThunk(
//   "publishAssessment/deletePublishAssessmentFromGroup",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(DELETE_ASSESSMENT_BATCH, {
//         data,
//         withCredentials: true,
//       });
//       return response;
//     } catch (err) {
//       return rejectWithValue(err.response.data);
//     }
//   },
// );

export const deleteBatchAssessment = createAsyncThunk(
  "publishAssessment/deleteBatchAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(DELETE_BATCH, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const forceDeletePublishAssessment = createAsyncThunk(
  "publishAssessment/forceDeletePublishAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(FORCE_DELETE_PUBLISH, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

const publishAssessmentSlice = createSlice({
  name: "publishAssessment",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    publishAssessmentData: [],
    nonPublishAssessmentData: [],
    batchAssessmentReminderUsersData:{},
    batchDataByTracking:[],
    batchAssessmentData: {},
    batchAssessmentListViewData: {},
    previewRimnderData: null,
    selectedData: {},
    assessorSelectedData:{}
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.selectedData = action?.payload.length > 0 && action?.payload[0];
    },
     assessorRowSelect: (state, action) => {
      state.assessorSelectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createPublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [createPublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createPublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

     [sendReminderByUserId.pending]: (state, action) => {
      state.loading = true;
    },
    [sendReminderByUserId.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [sendReminderByUserId.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [createBatchPublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [createBatchPublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createBatchPublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [createAssessmentExistingBatch.pending]: (state, action) => {
      state.loading = true;
    },
    [createAssessmentExistingBatch.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createAssessmentExistingBatch.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [publishBatchAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [publishBatchAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [publishBatchAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [publishBatchAssessmentReminder.pending]: (state, action) => {
      state.loading = true;
    },
    [publishBatchAssessmentReminder.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [publishBatchAssessmentReminder.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [getBatchPublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [getBatchPublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.batchAssessmentData = action?.payload?.data;
    },
    [getBatchPublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getBatchPreviewByAssessmentIds.pending]: (state, action) => {
      state.loading = true;
    },
    [getBatchPreviewByAssessmentIds.fulfilled]: (state, action) => {
      state.loading = false;
      state.batchAssessmentReminderUsersData = action?.payload?.data;
    },
    [getBatchPreviewByAssessmentIds.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getPublishPreviewReminderByAssessmentId.pending]: (state, action) => {
      state.loading = true;
    },
    [getPublishPreviewReminderByAssessmentId.fulfilled]: (state, action) => {
      state.loading = false;
      state.batchAssessmentReminderUsersData = action?.payload?.data;
    },
    [getPublishPreviewReminderByAssessmentId.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getBatchByTrackingId.pending]: (state, action) => {
      state.loading = true;
    },
    [getBatchByTrackingId.fulfilled]: (state, action) => {
      state.loading = false;
      state.batchDataByTracking = action?.payload?.data;
    },
    [getBatchByTrackingId.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getBatchNonPublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [getBatchNonPublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.nonPublishAssessmentData = action?.payload?.data;
    },
    [getBatchNonPublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getBatchPublishAssessmentById.pending]: (state, action) => {
      state.loading = true;
    },
    [getBatchPublishAssessmentById.fulfilled]: (state, action) => {
      state.loading = false;
      state.batchAssessmentData = action?.payload?.data;
      state.batchAssessmentListViewData = action?.payload?.data;
    },
    [getBatchPublishAssessmentById.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [publishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [publishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [publishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [getPublishAssessmentById.pending]: (state, action) => {
      state.loading = true;
    },
    [getPublishAssessmentById.fulfilled]: (state, action) => {
      state.loading = false;
      state.publishAssessmentData = action?.payload?.data;
    },
    [getPublishAssessmentById.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getArchivedPublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [getArchivedPublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.publishAssessmentData = action?.payload?.data;
    },
    [getArchivedPublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getPreviewReminderById.pending]: (state, action) => {
      state.loading = true;
    },
    [getPreviewReminderById.fulfilled]: (state, action) => {
      state.loading = false;
      state.previewRimnderData = action?.payload?.data;
    },
    [getPreviewReminderById.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getPublishPreviewReminderById.pending]: (state, action) => {
      state.loading = true;
    },
    [getPublishPreviewReminderById.fulfilled]: (state, action) => {
      console.log(action?.payload?.data);
      state.loading = false;
      state.previewRimnderData = action?.payload?.data;
    },
    [getPublishPreviewReminderById.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getPublishAssessmentByCustomerId.pending]: (state, action) => {
      state.loading = true;
    },
    [getPublishAssessmentByCustomerId.fulfilled]: (state, action) => {
      state.loading = false;
      state.publishAssessmentData = action?.payload?.data;
    },
    [getPublishAssessmentByCustomerId.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getPublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [getPublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.publishAssessmentData = action?.payload?.data;
    },
    [getPublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [updatePublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [updatePublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updatePublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [updateBatchPublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [updateBatchPublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateBatchPublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [updateArchivedPublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [updateArchivedPublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateArchivedPublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [deletePublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [deletePublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deletePublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

     [forceDeletePublishAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [forceDeletePublishAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [forceDeletePublishAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [deletePublishAssessmentFromGroup.pending]: (state, action) => {
      state.loading = true;
    },
    [deletePublishAssessmentFromGroup.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deletePublishAssessmentFromGroup.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [deleteBatchAssessment.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteBatchAssessment.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteBatchAssessment.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [batchUploadCustomerUser.pending]: (state, action) => {
      state.loading = true;
    },
    [batchUploadCustomerUser.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = "Bulk Users Uploaded Successfully";
    },
    [batchUploadCustomerUser.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = "Bulk users upload failed";
    },
  },
});

export const { resetMessage, resetErrMessage,  assessorRowSelect, rowSelect } =
  publishAssessmentSlice.actions;
export default publishAssessmentSlice.reducer;
